export const socketPayloadType = {
    ACCEPT: 'ACCEPT',
    RE_ACCEPT: 'RE_ACCEPT',
    ALLOCATED: 'ALLOCATED',
    ALLOCATED_CANCEL: 'ALLOCATED_CANCEL',
    PICKUP_ARRIVE: 'PICKUP_ARRIVE',
    PICKUP_FINISH: 'PICKUP_FINISH',
    DROP_FINISH: 'DROP_FINISH',
    CANCEL: 'CANCEL',
    DROP_INFO: 'DROP_INFO',
    PAY_AMOUNT: 'PAY_AMOUNT',
    CUSTOMER_PHONE: 'CUSTOMER_PHONE',
    RESERVATION_TIME: 'RESERVATION_TIME',
    PICKUP_EXPECTTIME: 'PICKUP_EXPECTTIME',
    DELIVERY_CHARGE: 'DELIVERY_CHARGE',
    PAYMENT: 'PAYMENT',
    PAYMENT_CANCEL: 'PAYMENT_CANCEL',
    WORKER_REQUEST: 'WORKER_REQUEST',
    PAYTYPE: 'PAYTYPE',
};
